
import React, { useState } from 'react';
import { Mail, ArrowLeft, Loader, CheckCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { API_BASE } from '../config';

export default function ForgotPassword({ t }) {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);

    try {
      const response = await fetch(`${API_BASE}/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      const data = await response.json();
      setMessage(data.message || t.auth.emailSent);
    } catch (err) {
      console.error(err);
      setMessage(t.auth.emailSent);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-pink-50 via-white to-purple-50 px-4">
      <div className="bg-white p-8 rounded-2xl shadow-xl w-full max-w-md border border-gray-100">
        <Link to="/login" className="flex items-center text-gray-600 hover:text-pink-600 mb-6 transition-colors"><ArrowLeft className="h-5 w-5 mr-1" />{t.auth.backToLogin}</Link>
        <h2 className="text-2xl font-bold text-gray-800 mb-4">{t.auth.forgotPassword}</h2>
        {message ? (
          <div className="p-4 bg-green-50 text-green-700 rounded-lg flex items-center"><CheckCircle className="h-5 w-5 mr-2" />{message}</div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="text-sm font-medium text-gray-700 block mb-1">{t.auth.email}</label>
              <div className="relative"><Mail className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" /><input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-pink-500" placeholder="name@example.com" /></div>
            </div>
            <button type="submit" disabled={loading} className="w-full bg-pink-600 text-white py-2.5 rounded-lg font-semibold hover:bg-pink-700 transition-colors flex justify-center items-center">
              {loading ? <Loader className="animate-spin h-5 w-5" /> : t.auth.sendResetLink}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
